import React from 'react';
import styled from 'styled-components';
import palette from '../../lib/styles/palette';
import { Button, Form, Input, Label } from 'semantic-ui-react';
import useUser from '../../hooks/user/useUser';
import useInput from '../../hooks/common/useInput';
import moment from 'moment';
const PointBlock = styled.div`
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .white-box{
        box-shadow : 0px 2px 4px rgba(0, 0, 0, 0.2);
        padding: 2rem;
        min-width: 360px;
        .log-list{
            max-height: 50vh;
            overflow-y: scroll;
        }
    }
    footer{
        padding: 1rem;
        .button-row{
            display: flex;
            justify-content: flex-end;
        }
    }
`;

const LogBlock = styled.div`
    padding-top: .75rem;
    padding-bottom: .75rem;
    
    border-bottom: 1px solid rgba(212, 212, 212, 0.5);
    .log-row{
        display: flex;
        justify-content: space-between;
        margin-bottom: 1rem;
        span{
            
        }
        .date{
            color: rgb(190, 190, 190);
        }
    }
    .header-row{
        span{
            font-weight: bold;
        }
    }
`;

const Point = () => {
    const {user, searchUser} = useUser();
    const nameInput = useInput('name');
    const phoneInput = useInput('phone');

    const userLogs = user?.logs?.map( log => {
        const { date, newPoint, price, spot, usePoint } = log;
        return (
            <LogBlock>
                <div className='log-row header-row'>
                    <Label horizontal color='green'>적립</Label>
                    <span>+{newPoint} P</span>
                </div>
                {
                    usePoint != 0 && (
                        <div className='log-row header-row'>
                            <Label horizontal color='red'>사용</Label>
                            <span>-{usePoint} P</span>
                        </div>
                    )
                }
                {/* <div className='log-row'>
                    <label>결제금액</label>
                    {price} 원
                </div> */}
                <div className='log-row'>
                    <span>
                        이용매장: {spot}
                    </span>
                    <span className='date'>
                        {moment(new Date(date)).format('YYYY-MM-DD hh:mm')}
                    </span>
                </div>
                
                
                
            </LogBlock>
        )
    })
    const currentPoint = user?.points?.reduce((acc, p) => p.point + acc, 0);
    return (
        <PointBlock>
            <div className='white-box'>
                <h3>맴버십 포인트 내역 / 현황 조회</h3>
                <Form>
                    <Form.Input label='이름' placeholder='이름을 입력해주세요' {...nameInput}></Form.Input>
                    <Form.Input label='전화번호' placeholder='전화번호를 입력해주세요' {...phoneInput}></Form.Input>
                    <Form.Button fluid primary onClick={() => searchUser(nameInput.value, phoneInput.value)}>조회</Form.Button>
                </Form>
                {
                    currentPoint && (
                        <h3>
                            현재 포인트 : {currentPoint} P
                        </h3>
                    )
                }
                <div className='log-list'>
                {
                    userLogs
                }
                </div>
                
            </div>
            <footer>
    
                <h3>이용안내</h3> 
                <p>
                    매장에서 가입한 고객정보로 포인트 조회가 가능합니다.<br/>
                    (해당 조회 결과는 전날 기준)<br/>
                    2021-06-08 이전 포인트 내역은 한꺼번에 <br/>
                    2021-06-08 날짜로 통합되어 표시 됩니다.<br/>
                    (이후는 적립/사용 날짜로 표시됨)
                </p>
                
                <h3>
                    문의사항
                </h3>
                <p>
                    매장에서 성함과 전화번호를 잘못 입력 하면 조회가 되지 않습니다.<br/>
                    조회가 되지않는경우 카카오톡 채널로 문의해주세요
                </p>
                <p className='button-row'>
                    <a href="http://pf.kakao.com/_lShlu/chat">
                        <Button color="yellow" basic>카카오톡 채널 바로가기</Button>
                    </a>
                </p>
            </footer>
        </PointBlock>
    )
}

export default Point;